module.exports = __webpack_public_path__ + "img/ring_r_l_0_null.f75d3fd7.png";